/* eslint-disable strict */
/* eslint-disable react/no-danger */

'use strict';

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SHOWMODAL } from '../../../actions/constantsActions';
import { converter } from '../../../helpers/converter';

export class FbAccountRemove extends React.Component {
  onDetachedFacebook = () => {
    this.props.onDetachedFacebook({});
  };

  render() {
    return (
      <div id="social_estado">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 padding-top-05">
              <p
                dangerouslySetInnerHTML={{
                  __html: converter.convertApaUnicode(
                    this.props.translations,
                    'profile_social_fb_detach',
                    'Puedes <b>"Desvincular"</b> tu cuenta de Facebook de <b>Clarovideo</b> en el momento que desees.',
                  ),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-1 col-md-2 col-sm-2 col-xs-3 padding-1">
          <img
            className="thumb-img-fb"
            alt="user_img"
            src={this.props.facebookData.image}
          />
        </div>
        <div className="col-lg-6 col-md-5 col-sm-6 col-xs-9 padding-1">
          <div className="row">
            <div className="form-group">
              <label className="col-lg-4 col-md-5 col-sm-6 col-xs-6">
                <p>
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_firstname',
                    'Nombre',
                  )}
                </p>
              </label>
              <div className="col-lg-8 col-md-7 col-sm-6 col-xs-6">
                <p>{this.props.facebookData.name}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-3">
          <span
            id="cargando"
            className="full-width padding-2"
            style={{ display: 'none' }}
          >
            <img
              alt="loading"
              width="54"
              className="center-block"
              src="https://clarovideocdn0.clarovideo.net/fe/sitesplus/sk_core/images/cargando.gif"
            />
          </span>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 padding-top-1">
          <button
            type="button"
            id="btnSubmit"
            action="desvincular"
            className="btn btn-fb btn-default btn-block margin-05"
            onClick={this.onDetachedFacebook}
          >
            <i className="fa fa-facebook padding-right-1" />
            {converter.convertApaUnicode(
              this.props.translations,
              'profile_social_network_button_link_detach',
              'Desvincular',
            )}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
});

const showModal = modal => ({
  type: SHOWMODAL,
  modal,
});

FbAccountRemove.propTypes = {
  onDetachedFacebook: PropTypes.func,
  translations: PropTypes.shape({}),
  facebookData: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string,
  }),
};
export default connect(
  mapStateToProps,
  { showModal },
)(FbAccountRemove);
